import { zillowApi } from "api/zillow";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const ZillowView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnectZillow, isPending: isDisconnecting } = useMutation({
    mutationKey: ["ZILLOW", "DELETE"],
    mutationFn: () => zillowApi.disconnect(),
    onSuccess: () => {
      toast.success("Zillow integration disconnected successfully");
      refreshPartnerData();
      navigate("/settings/integration");
    },
    onError: (err) => {
      toast.error(getErrorMessage(err));
    }
  });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.ZILLOW}
          name="Zillow"
          path="/settings/integration/zillow"
          onDisconnect={() => disconnectZillow()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <FeedListingsCard feed="zillow" feedLabel="Zillow" />
    </Layout>
  );
};
